import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoTrim: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideoTrim"><Path fillRule="evenodd" clipRule="evenodd" d="M16 22H14.5V20H2V4H14.5V2H16V22ZM6.75 8.25V15.75L11.75 12L6.75 8.25Z" fill="currentColor"/><Path d="M18 4H22V20H18V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoTrim;
